import Swal from "sweetalert2";
import store from "@/state/store";
import api from "../api";

let componentPermissions = {
  home: {},
  dashboard: {},
  training: {},
  "pl-aside-page": {},
  support: {},
  Video: {},
  Faqs: {},
  "meetings-events": {},
  "meetings-minutes": {},
  "view-all-page": {},
  "pcn-staff": {},
  "pcn-news-edit": {},
  "member-practices": {},
  Analytics: {
    Practice: [
      "READ",
      "CREATE",
      "UPDATE",
      "UPDATEMANY",
      "DELETE",
      "LIST",
      "COUNT",
      "EXECUTE",
    ],
  },
  analyticsresult: {
    Practice: [
      "READ",
      "CREATE",
      "UPDATE",
      "UPDATEMANY",
      "DELETE",
      "LIST",
      "COUNT",
      "EXECUTE",
    ],
  },
  Users: {
    User: [
      "READ",
      "CREATE",
      "UPDATE",
      "UPDATEMANY",
      "DELETE",
      "LIST",
      "COUNT",
      "EXECUTE",
    ],
  },
  Practices: {
    User: [
      "READ",
      "CREATE",
      "UPDATE",
      "UPDATEMANY",
      "DELETE",
      "LIST",
      "COUNT",
      "EXECUTE",
    ],
  },
  Forms: {
    User: [
      "READ",
      "CREATE",
      "UPDATE",
      "UPDATEMANY",
      "DELETE",
      "LIST",
      "COUNT",
      "EXECUTE",
    ],
  },
  "Form Builder": {
    User: [
      "READ",
      "CREATE",
      "UPDATE",
      "UPDATEMANY",
      "DELETE",
      "LIST",
      "COUNT",
      "EXECUTE",
    ],
  },
  Pages: {
    User: [
      "READ",
      "CREATE",
      "UPDATE",
      "UPDATEMANY",
      "DELETE",
      "LIST",
      "COUNT",
      "EXECUTE",
    ],
  },
  "Info Pages": {
    User: [
      "READ",
      "CREATE",
      "UPDATE",
      "UPDATEMANY",
      "DELETE",
      "LIST",
      "COUNT",
      "EXECUTE",
    ],
  },
  Admin: {
    User: [
      "READ",
      "CREATE",
      "UPDATE",
      "UPDATEMANY",
      "DELETE",
      "LIST",
      "COUNT",
      "EXECUTE",
    ],
  },
  "Practice Team": {
    User: [
      "READ",
      "CREATE",
      "UPDATE",
      "UPDATEMANY",
      "DELETE",
      "LIST",
      "COUNT",
      "EXECUTE",
    ],
  },
  "Opening Hours": {
    User: [
      "READ",
      "CREATE",
      "UPDATE",
      "UPDATEMANY",
      "DELETE",
      "LIST",
      "COUNT",
      "EXECUTE",
    ],
  },
  "Opening Hours Page": {
    User: [
      "READ",
      "CREATE",
      "UPDATE",
      "UPDATEMANY",
      "DELETE",
      "LIST",
      "COUNT",
      "EXECUTE",
    ],
  },
  News: {
    User: [
      "READ",
      "CREATE",
      "UPDATE",
      "UPDATEMANY",
      "DELETE",
      "LIST",
      "COUNT",
      "EXECUTE",
    ],
  },
  Documents: {
    User: [
      "READ",
      "CREATE",
      "UPDATE",
      "UPDATEMANY",
      "DELETE",
      "LIST",
      "COUNT",
      "EXECUTE",
    ],
  },
  Alerts: {
    User: [
      "READ",
      "CREATE",
      "UPDATE",
      "UPDATEMANY",
      "DELETE",
      "LIST",
      "COUNT",
      "EXECUTE",
    ],
  },
  "Information Pages": {
    User: [
      "READ",
      "CREATE",
      "UPDATE",
      "UPDATEMANY",
      "DELETE",
      "LIST",
      "COUNT",
      "EXECUTE",
    ],
  },
  "Policy Pages": {
    User: [
      "READ",
      "CREATE",
      "UPDATE",
      "UPDATEMANY",
      "DELETE",
      "LIST",
      "COUNT",
      "EXECUTE",
    ],
  },
  Locations: {
    User: [
      "READ",
      "CREATE",
      "UPDATE",
      "UPDATEMANY",
      "DELETE",
      "LIST",
      "COUNT",
      "EXECUTE",
    ],
  },
  "Mass Update": {
    User: [
      "READ",
      "CREATE",
      "UPDATE",
      "UPDATEMANY",
      "DELETE",
      "LIST",
      "COUNT",
      "EXECUTE",
    ],
  },
  PCN: {
    User: [
      "READ",
      "CREATE",
      "UPDATE",
      "UPDATEMANY",
      "DELETE",
      "LIST",
      "COUNT",
      "EXECUTE",
    ],
  },
  "Staff Availability": {
    User: [
      "READ",
      "CREATE",
      "UPDATE",
      "UPDATEMANY",
      "DELETE",
      "LIST",
      "COUNT",
      "EXECUTE",
    ],
  },
  "Create Form": {
    User: [
      "READ",
      "CREATE",
      "UPDATE",
      "UPDATEMANY",
      "DELETE",
      "LIST",
      "COUNT",
      "EXECUTE",
    ],
  },
  Support: {
    User: [
      "READ",
      "CREATE",
      "UPDATE",
      "UPDATEMANY",
      "DELETE",
      "LIST",
      "COUNT",
      "EXECUTE",
    ],
  },
  "Network News": {
    User: [
      "READ",
      "CREATE",
      "UPDATE",
      "UPDATEMANY",
      "DELETE",
      "LIST",
      "COUNT",
      "EXECUTE",
    ],
  },
  "Meeting & Events": {
    User: [
      "READ",
      "CREATE",
      "UPDATE",
      "UPDATEMANY",
      "DELETE",
      "LIST",
      "COUNT",
      "EXECUTE",
    ],
  },
  "Meeting Minutes": {
    User: [
      "READ",
      "CREATE",
      "UPDATE",
      "UPDATEMANY",
      "DELETE",
      "LIST",
      "COUNT",
      "EXECUTE",
    ],
  },
  Videos: {
    User: [
      "READ",
      "CREATE",
      "UPDATE",
      "UPDATEMANY",
      "DELETE",
      "LIST",
      "COUNT",
      "EXECUTE",
    ],
  },
  "Member Practices": {
    User: [
      "READ",
      "CREATE",
      "UPDATE",
      "UPDATEMANY",
      "DELETE",
      "LIST",
      "COUNT",
      "EXECUTE",
    ],
  },
  FAQs: {
    User: [
      "READ",
      "CREATE",
      "UPDATE",
      "UPDATEMANY",
      "DELETE",
      "LIST",
      "COUNT",
      "EXECUTE",
    ],
  },
};

const ifAuthenticated = (to, from, next) => {
  if (to.name == "root") {
    next({ name: "login" });
    return;
  }
  if (sessionStorage.getItem("currentUser") != null) {
    if (JSON.parse(sessionStorage.getItem("currentUser")).token) {
      for (const [key, value] of Object.entries(
        componentPermissions[to.name]
      )) {
        // console.log(key, value)
        if (
          Object.keys(
            JSON.parse(sessionStorage.getItem("currentUser")).permissions
          ).includes(key)
        ) {
          for (let per of value) {
            if (
              JSON.parse(sessionStorage.getItem("currentUser")).permissions[
                key
              ][per]
            ) {
              // console.log(JSON.parse(sessionStorage.getItem('currentUser')).permissions[key][per])
              continue;
            }
            // console.log(JSON.parse(sessionStorage.getItem('currentUser')).permissions[key][per])
            else {
              if (
                JSON.parse(sessionStorage.getItem("currentUser")).permissions[
                  "User"
                ][per]
              ) {
                next({ name: "Pages" });
                Swal.fire(
                  "Access Denied!",
                  "Contact Administrator for access.",
                  "error"
                );
              }
              next({ name: "home" });
            }
          }
        } else {
          next({ name: "Pages" });
          Swal.fire(
            "Access Denied!",
            "Contact Administrator for access.",
            "error"
          );
        }
      }
      // for (let str in componentPermissions[to.name]) {
      //     console.log(str)
      //     if (Object.keys(JSON.parse(sessionStorage.getItem('currentUser')).permissions).includes(str)) {
      //         continue;
      //     }
      //     else {
      //         next({ name: 'home' })
      //         Swal.fire("Access Denied!", "Contact Administrator for access.", "error");
      //     }
      // }
      next();
      return;
    }
  }
  next({ name: "login" });
};

// const ifAdmin = (to, from, next) => {
//     if (sessionStorage.getItem('currentUser') != null) {
//         if(JSON.parse(sessionStorage.getItem('currentUser')).isAdmin)
//         {
//             next();
//             return;
//         }
//     }
//     next({ name: 'home' })
// };

export default [
  {
    path: "/login",
    name: "login",
    component: () => import("../views/pages/account/login"),
    beforeEnter(to, from, next) {
      if (
        sessionStorage.getItem("currentUser") == null ||
        JSON.parse(sessionStorage.getItem("currentUser")).token == null
      ) {
        next();
        return;
      }
      let temp_user = JSON.parse(sessionStorage.getItem("currentUser"));
      if (temp_user.name == "Super Admin") {
        let url = "/api/pcns";
        let filter = {
          include: [
            {
              relation: "practices",
              scope: {
                include: [
                  {
                    relation: "practiceData",
                    scope: {
                      include: [
                        {
                          relation: "cms",
                        },
                      ],
                    },
                  },
                ],
              },
            },
            {
              relation: "practiceData",
              scope: {
                include: [
                  {
                    relation: "cms",
                  },
                ],
              },
            },
          ],
        };
        filter = encodeURIComponent(JSON.stringify(filter));
        url = `${url}?filter=${filter}`;
        api
          .get(url)
          .then((response) => {
            if (response.data.length != 0) {
              var firstNetwork = response.data[0];
              var firstPrac = firstNetwork.practices[0];
              next({
                name: "Pages",
                params: {
                  netId: firstNetwork.practiceData.cms.id,
                  cmsId: firstPrac.practiceData.cms.id,
                },
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        let url = "/users/" + temp_user.id + "/practicesWithCms";
        api
          .get(url)
          .then((response) => {
            if (response.data.length != 0) {
              var firstPrac = response.data[0];
              next({
                name: "Pages",
                params: {
                  netId: firstPrac.pcnId,
                  cmsId: firstPrac.practiceData.cms.id,
                },
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
  },
  {
    path: "/login-via-code",
    name: "Login Via Code",
    component: () => import("../views/pages/account/login-via-code"),
  },
  {
    path: "/logout",
    name: "logout",
    beforeEnter(routeTo, routeFrom, next) {
      store.commit("updateCurrentUser", null);
      store.commit("updateCurrentPractice", null);
      store.commit("updateCurrentPracticeData", null);
      store.commit("updateCurrentCms", null);
      store.commit("updateCurrentPcn", null);
      if (sessionStorage.getItem("currentUser") != null) {
        sessionStorage.removeItem("currentUser");
      }
      next({ name: "login" });
    },
  },
  {
    path: "/",
    name: "root",
    beforeEnter: ifAuthenticated,
    // component: () => import('../views/pages/account/login'),
  },
  {
    path: "/home/:netId/:cmsId",
    name: "home",
    beforeEnter: ifAuthenticated,
    component: () => import("../views/pages/pcn-home/index"),
  },
  {
    path: "/dashboard",
    name: "dashboard",
    beforeEnter: ifAuthenticated,
    component: () => import("../views/pages/dashboard/index"),
  },
  {
    path: "/training/:netId/:cmsId",
    name: "training",
    beforeEnter: ifAuthenticated,
    component: () => import("../views/pages/training/index"),
  },
  {
    path: "/pl-aside-page/:pageId",
    name: "pl-aside-page",
    beforeEnter: ifAuthenticated,
    component: () => import("../views/pages/pl-aside-page/index"),
  },
  {
    path: "/support/:netId/:cmsId",
    name: "support",
    beforeEnter: ifAuthenticated,
    component: () => import("../views/pages/support/index"),
  },
  {
    path: "/analytics/:netId/:cmsId",
    name: "Analytics",
    // meta: {
    //     authRequired: true,
    // },
    beforeEnter: ifAuthenticated,
    component: () => import("../views/pages/analytics/index"),
  },
  {
    path: "/playground",
    name: "playground",
    component: () => import("../views/pages/analytics/MapFeature.vue"),
  },
  {
    path: "/analytics/:netId/:cmsId/analyticsresult",
    name: "analyticsresult",
    beforeEnter: ifAuthenticated,
    component: () => import("../views/pages/analytics/index"),
  },
  {
    path: "/support",
    name: "Support",
    // meta: {
    //     authRequired: true,
    // },
    beforeEnter: ifAuthenticated,
    component: () => import("../views/pages/support/index"),
  },
  {
    path: "/network/:netId/:cmsId",
    name: "Network",
    // meta: {
    //     authRequired: true,
    // },
    // beforeEnter: ifAuthenticated,
    component: () => import("../views/pages/network/index"),
  },
  {
    path: "/icb/:netId/:cmsId",
    name: "ICB",
    // meta: {
    //     authRequired: true,
    // },
    // beforeEnter: ifAuthenticated,
    component: () => import("../views/pages/icb/index"),
  },
  {
    path: "/forgot-password",
    name: "Forgot Password",
    // meta: { authRequired: true },
    component: () => import("../views/pages/sample-auth/recoverpwd-1"),
  },
  {
    path: "/users/:netId/:cmsId",
    name: "Users",
    beforeEnter: ifAuthenticated,
    component: () => import("../views/pages/users/index"),
  },
  {
    path: "/audit/:netId/:cmsId",
    name: "Audit",
    // beforeEnter: ifAuthenticated,
    component: () => import("../views/pages/audit/index"),
  },
  {
    path: "/productnews/:netId/:cmsId/:catId",
    name: "Product News",
    // beforeEnter: ifAuthenticated,
    component: () => import("../views/pages/productnews/index"),
  },
  {
    path: "/practices/:netId/:cmsId",
    name: "Practices",
    beforeEnter: ifAuthenticated,
    component: () => import("../views/pages/practices/index"),
  },
  {
    path: "/pcns/:netId/:cmsId",
    name: "PCN",
    beforeEnter: ifAuthenticated,
    component: () => import("../views/pages/pcn/index"),
  },
  {
    path: "/forms",
    name: "Forms",
    beforeEnter: ifAuthenticated,
    component: () => import("../views/pages/forms/index"),
  },
  {
    path: "/form-builder",
    name: "Form Builder",
    beforeEnter: ifAuthenticated,
    component: () => import("../views/form-builder/index"),
  },
  {
    path: "/settings/:netId/:cmsId",
    name: "Settings",
    // beforeEnter: ifAuthenticated,
    component: () => import("../views/pages/settings/index"),
  },
  {
    path: "/pages/view-all-page/:slug",
    name: "view-all-page",
    beforeEnter: ifAuthenticated,
    component: () => import("../views/pages/view-all-page/index"),
    props: true,
  },
  {
    path: "/pages/productnews/view-all-page/:slug",
    name: "view-all-page",
    beforeEnter: ifAuthenticated,
    component: () => import("../views/pages/product-news/index.vue"),
    props: true,
  },
  {
    path: "/pages/:netId/:cmsId",
    name: "Pages",
    beforeEnter: ifAuthenticated,
    component: () => import("../views/pages/index"),
  },
  {
    path: "/admin/:slug",
    name: "Admin",
    beforeEnter: ifAuthenticated,
    component: () => import("../views/pages/admin/index"),
    props: true,
  },
  {
    path: "/admin/roles/:netId/:cmsId",
    name: "Permissions",
    // beforeEnter: ifAuthenticated,
    component: () => import("../views/pages/roles/index"),
    props: true,
  },
  {
    path: "/admin/mail/:netId/:cmsId",
    name: "Mail",
    // beforeEnter: ifAuthenticated,
    component: () => import("../views/pages/admin/index"),
    props: true,
  },
  {
    path: "/pages/practice-team",
    name: "Practice Team",
    beforeEnter: ifAuthenticated,
    component: () => import("../views/pages/practice-team/index"),
    props: true,
  },
  {
    path: "/pages/opening-hours",
    name: "Opening Hours",
    beforeEnter: ifAuthenticated,
    component: () => import("../views/pages/opening-hours/index"),
    props: true,
  },
  {
    path: "/pages/pages",
    name: "Info Pages",
    beforeEnter: ifAuthenticated,
    component: () => import("../views/pages/pages/index"),
    props: true,
  },
  {
    path: "/pages/opening-hours-page",
    name: "Opening Hours Page",
    beforeEnter: ifAuthenticated,
    component: () => import("../views/pages/opening-hours-page/index"),
  },
  {
    path: "/pages/news",
    name: "News",
    beforeEnter: ifAuthenticated,
    component: () => import("../views/pages/news/index"),
    props: true,
  },
  {
    path: "/pages/alerts",
    name: "Alerts",
    beforeEnter: ifAuthenticated,
    component: () => import("../views/pages/alerts/index"),
    props: true,
  },
  {
    path: "/pages/information-pages",
    name: "Information Pages",
    beforeEnter: ifAuthenticated,
    component: () => import("../views/pages/information-pages/index"),
    props: true,
  },
  {
    path: "/pages/policy-pages",
    name: "Policy Pages",
    beforeEnter: ifAuthenticated,
    component: () => import("../views/pages/policy-pages/index"),
    props: true,
  },
  {
    path: "/pcn/pcn-staff",
    name: "pcn-staff",
    beforeEnter: ifAuthenticated,
    component: () => import("../views/pages/pcn-staff/index"),
  },
  {
    path: "/pages/documents",
    name: "Documents",
    beforeEnter: ifAuthenticated,
    component: () => import("../views/pages/documents/index"),
    props: true,
  },
  {
    path: "/pages/locations",
    name: "Locations",
    beforeEnter: ifAuthenticated,
    component: () => import("../views/pages/locations/index"),
    props: true,
  },
  {
    path: "/pages/mass-update",
    name: "Mass Update",
    beforeEnter: ifAuthenticated,
    component: () => import("../views/pages/mass-update/index"),
  },
  {
    path: "/pages/staff-availability",
    name: "Staff Availability",
    beforeEnter: ifAuthenticated,
    component: () => import("../views/pages/staff-availability/index"),
  },
  {
    path: "/pages/:netId/:cmsId/:categoryName/:categoryId",
    name: "Dynamic Category Page",
    // beforeEnter: ifAuthenticated,
    component: () => import("../views/pages/category/index"),
  },
  {
    path: "/network/:netId/:cmsId/:categoryName/:categoryId",
    name: "Dynamic Network Category Page",
    // beforeEnter: ifAuthenticated,
    component: () => import("../views/pages/category/index"),
  },
  {
    path: "/icb/:netId/:cmsId/:categoryName/:categoryId",
    name: "Dynamic ICB Category Page",
    // beforeEnter: ifAuthenticated,
    component: () => import("../views/pages/category/index"),
  },
  {
    path: "/pages/create-form",
    name: "Create Form",
    beforeEnter: ifAuthenticated,
    component: () => import("../views/pages/create-form/index"),
  },

  // Network
  {
    path: "/network/news",
    name: "Network News",
    beforeEnter: ifAuthenticated,
    component: () => import("../views/pages/pcn-news-edit/index"),
    props: true,
  },
  {
    path: "/network/meetings-events",
    name: "Meeting & Events",
    beforeEnter: ifAuthenticated,
    component: () => import("../views/pages/meetings-events/index"),
    props: true,
  },
  {
    path: "/network/meetings-minutes",
    name: "Meeting Minutes",
    beforeEnter: ifAuthenticated,
    component: () => import("../views/pages/meetings-minutes/index"),
    props: true,
  },
  {
    path: "/network/video",
    name: "Videos",
    beforeEnter: ifAuthenticated,
    component: () => import("../views/pages/video/index"),
    props: true,
  },
  {
    path: "/network/member-practices",
    name: "Member Practices",
    beforeEnter: ifAuthenticated,
    component: () => import("../views/pages/member-practices/index"),
    props: true,
  },
  {
    path: "/network/faqs",
    name: "FAQs",
    beforeEnter: ifAuthenticated,
    component: () => import("../views/pages/faqs/index"),
    props: true,
  },

  {
    path: "*",
    name: "Error-404",
    // meta: { authRequired: true },
    component: () => import("../components/error-404"),
  },
];
